import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import UNIVERSAL from "../../../config/config";
import { loginActions } from "../../../store/login-slice";
import { sidebarActions } from "../../../store/sidebar-slice";
import { stepsActions } from "../../../store/steps-slice";
import { userActions } from "../../../store/user-slice";
import {
  Btn,
  Form,
  FormBottom,
  FormBottomLeft,
  FormHeader,
  Input,
  InputField,
  Left,
  LeftContent,
  Logo,
  Para,
  Right,
  RightDetail,
  SocialLogin,
  SubmitBtn,
  Wrapper,
} from "./Login.styles";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import OnBoardImage from "../../../assets/images/onboard-one.png";

import { Alert, Checkbox, InputAdornment, Link, Stack, Typography } from "@mui/material";
import { toast } from "react-toastify";
import ZocketLogo from "./zocketLogo/ZocketLogo";

const Login = () => {
  const [formType, setFormType] = useState("login");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);

  const [signupError, setSignupError] = useState(false);
  const [loginError, setLoginError] = useState(false);

  const isLogin = useSelector((state) => state.login.isLogin);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logoutHandler = () => {
    dispatch(loginActions.setToken(null));
    dispatch(loginActions.setIsLogin(false));
  };

  const do_email_signup = () => {};

  const handle_form_submit = (event) => {
    event.preventDefault();
    if (formType === "login") {
      setSignupError(false);
      setLoginError(false);
      if (email === "" || password === "") {
        setLoginError("Please fill all the fields");
      } else {
        if (!isLogin) {
          fetch(UNIVERSAL.BASEURL_2 + "/auth/api/v1/login-with-password", {
            method: "POST",
            body: JSON.stringify({
              username: email,
              password: password,
            }),
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then((res) => {
              if (res.ok) {
                return res.json();
              } else {
                return res.json().then(() => {
                  let errorMessage = "Authentication failed!";
                  setLoginError(errorMessage);
                });
              }
            })
            .then((data) => {
              if (!data.data.user) return alert("Authentication failed. User doesn't exist.");
              setTimeout(logoutHandler, data.data.expires_in);
              dispatch(loginActions.setToken(data.data.access_token));
              dispatch(stepsActions.selectedCategory(data.data.user.business_category));
              dispatch(loginActions.setIsLogin(true));
              dispatch(sidebarActions.setSidebar(true));
              dispatch(sidebarActions.setRoute("/"));
              localStorage.setItem("auth", JSON.stringify(data.data));
              dispatch(
                userActions.updateUser({
                  user: data.data.user,
                  username: data.data.username,
                })
              );
              navigate("/", { replace: true });
            })
            .catch((err) => {
              // alert(err.message);
            });
        }
      }
    } else {
      setSignupError(false);
      setLoginError(false);
      if (email === "" || password === "" || rePassword === "" || name === "") {
        setSignupError("Please fill all the fields");
      } else if (rePassword !== password) {
        setSignupError("Passwords do not match");
      } else {
        if (!isLogin) {
          fetch(UNIVERSAL.BASEURL_2 + "/auth/api/v1/signup", {
            method: "POST",
            body: JSON.stringify({
              email: email,
              full_name: name,
              password: password,
              referral_code: referralCode,
            }),
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then((res) => {
              if (res.ok) {
                return res.json();
              } else {
                res.json().then((data) => {
                  let errorMessage = data.error.message ?? "Unable to signup! Something went wrong, please try again.";
                  setSignupError(errorMessage);
                });
                return null;
              }
            })
            .then((data) => {
              if (!data || !data.data) return;
              if (!data.data.business_id) {
                setSignupError("Unable to signup! Something went wrong, please try again.");
              } else {
                toast("Signup successful! Please login with your credentials", { type: "success" });
                setFormType("login");
              }
            })
            .catch((err) => {
              toast(err.message, { type: "error" });
            });
        }
      }
    }
  };

  useEffect(() => {
    setLoginError(false);
    setSignupError(false);
  }, [formType]);

  return (
    <Wrapper>
      <Left>
        <LeftContent>
          <Logo>
            <ZocketLogo width="4rem" initialPos="140" />
            <h2>Zocket</h2>
          </Logo>
          <Stack>
            <img src={OnBoardImage} width="100%" height="100%" style={{ maxHeight: 450, objectFit: "cover" }} />
          </Stack>
          <Stack direction="column">
            <Typography variant="h5" fontWeight={600} color="black" textAlign="center">
              Stunning Social Media ads powered by Gen AI
            </Typography>
            <Typography color="black" textAlign="center">
              Easiest way to start running high performing digital campaigns
            </Typography>
          </Stack>
        </LeftContent>
      </Left>
      <Right>
        <RightDetail>
          <Logo>
            <ZocketLogo width="4rem" initialPos="140" />
            <h2>Zocket</h2>
          </Logo>
        </RightDetail>
        <div className="container">
          {formType !== "forgotPassword" && (
            <SocialLogin>
              {formType === "login" && (
                <>
                  <FormHeader>Login to your account</FormHeader>
                  <Para>Enter your credentials to access your account</Para>
                </>
              )}
              {formType === "signup" && (
                <>
                  <FormHeader>Sign up for an account</FormHeader>
                  <Para>Enter these below details to create your account</Para>
                </>
              )}
            </SocialLogin>
          )}
          {formType !== "forgotPassword" && (
            <Form onSubmit={(e) => handle_form_submit(e)} autoComplete="off">
              {signupError && formType === "signup" && (
                <Alert sx={{ marginBottom: "1rem" }} severity="error">
                  {signupError}
                </Alert>
              )}
              {loginError && formType === "login" && (
                <Alert sx={{ marginBottom: "1rem" }} severity="error">
                  {loginError}
                </Alert>
              )}
              {formType === "signup" && (
                <Input>
                  <InputField size="medium" fullWidth label="Full Name" value={name} onChange={(e) => setName(e.target.value)} autoComplete="off" />
                </Input>
              )}
              <Input>
                <InputField type="email" size="medium" fullWidth label="Email Address" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="off" />
              </Input>
              <Input>
                <InputField
                  type={passwordVisible ? "text" : "password"}
                  size="medium"
                  fullWidth
                  label="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="off"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" style={{ cursor: "pointer" }} onClick={() => setPasswordVisible(!passwordVisible)}>
                        {passwordVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      </InputAdornment>
                    ),
                  }}
                />
              </Input>
              {formType === "signup" && (
                <>
                  <Input>
                    <InputField
                      type="password"
                      size="medium"
                      label="Confirm Password"
                      fullWidth
                      value={rePassword}
                      onChange={(e) => setRePassword(e.target.value)}
                      autoComplete="off"
                    />
                  </Input>
                  <Input>
                    <InputField
                      type="text"
                      size="medium"
                      label="Referral Code (optional)"
                      fullWidth
                      value={referralCode}
                      onChange={(e) => setReferralCode(e.target.value)}
                      autoComplete="off"
                    />
                  </Input>
                </>
              )}
              {formType === "login" && (
                <FormBottom>
                  <FormBottomLeft>
                    <Checkbox size="medium" />
                    <Para style={{ marginLeft: -4 }}>Remember me</Para>
                  </FormBottomLeft>
                  <div />
                  <Link onClick={() => navigate("/reset_password")} sx={{ cursor: "pointer", fontWeight: 500 }}>
                    Forgot password?
                  </Link>
                </FormBottom>
              )}
              {formType === "login" && (
                <SubmitBtn>
                  <Btn
                    type="submit"
                    sx={{
                      width: "100%",
                      borderRadius: "0.75rem",
                      textTransform: "none",
                      fontFamily: "Poppins, sans-serif",
                    }}
                    variant="contained"
                  >
                    Sign In
                  </Btn>
                  <Para>
                    Don&apos;t have an account?&nbsp;
                    <Link sx={{ cursor: "pointer", fontWeight: 600 }} onClick={() => setFormType("signup")}>
                      Sign up
                    </Link>
                  </Para>
                </SubmitBtn>
              )}
              {formType === "signup" && (
                <SubmitBtn>
                  <Btn
                    type="submit"
                    sx={{
                      width: "100%",
                      borderRadius: "0.75rem",
                      textTransform: "none",
                      fontFamily: "Poppins, sans-serif",
                    }}
                    variant="contained"
                  >
                    Sign Up
                  </Btn>
                  <Para>
                    Already have an account?&nbsp;
                    <Link sx={{ cursor: "pointer", fontWeight: 600 }} onClick={() => setFormType("login")}>
                      Sign In
                    </Link>
                  </Para>
                </SubmitBtn>
              )}
            </Form>
          )}
        </div>
      </Right>
    </Wrapper>
  );
};

export default Login;
